export default __webpack_public_path__ + "static/media/flex-office.aae91069.svg";